import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FeedbackModal } from '@/components/feedback/FeedbackModal'
import { BottomNavTab, MoreTabButton } from '@/components/layout/mobile-nav/BottomNavTab'
import { MobileMoreSheet } from '@/components/layout/mobile-nav/MobileMoreSheet'
import { MORE_LINKS, TABS, isTabActive } from '@/components/layout/mobile-nav/mobileNavConfig'
import { useLogout } from '@/hooks/auth/useLogout'
import { useAuthStore } from '@/store/authStore'
import { useFilterStore } from '@/store/filterStore'

export default function MobileBottomNav() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const { showHidden, collapseVariants } = useFilterStore()
  const location = useLocation()
  const navigate = useNavigate()
  const [moreOpen, setMoreOpen] = useState(false)
  const [feedbackOpen, setFeedbackOpen] = useState(false)
  const logoutMutation = useLogout()

  if (!isAuthenticated) return null

  const moreActive = MORE_LINKS.some((link) => isTabActive(location.pathname, link.to))

  const handleLogout = async () => {
    await logoutMutation.mutateAsync()
    navigate('/login')
    setMoreOpen(false)
  }

  return (
    <>
      <MobileMoreSheet
        isOpen={moreOpen}
        onClose={() => setMoreOpen(false)}
        onOpenFeedback={() => setFeedbackOpen(true)}
        onLogout={handleLogout}
      />

      {/* Bottom nav bar */}
      <nav className="fixed bottom-0 left-0 right-0 z-40 bg-elevated border-t border-theme-border md:hidden safe-area-bottom">
        <div className="flex items-stretch h-14">
          {TABS.map((tab) =>
            tab.id === 'more' ? (
              <MoreTabButton
                key={tab.id}
                tab={tab}
                active={moreActive}
                open={moreOpen}
                showIndicator={collapseVariants || showHidden}
                onToggle={() => setMoreOpen(!moreOpen)}
              />
            ) : (
              <BottomNavTab
                key={tab.id}
                tab={tab}
                active={isTabActive(location.pathname, tab.to)}
                onNavigate={() => setMoreOpen(false)}
              />
            ),
          )}
        </div>
      </nav>
      <FeedbackModal isOpen={feedbackOpen} onClose={() => setFeedbackOpen(false)} />
    </>
  )
}
